import { DataGridPro, esES, gridFilteredSortedRowIdsSelector, GridFooter, LicenseInfo, useGridApiContext } from "@mui/x-data-grid-pro";
// functions
import { formatNumber, generateColumns } from "../../../services/Local-services";
// recoil
import { useRecoilValue, useRecoilState } from "recoil";
import { routeInfo, rowSelected } from "../../../recoilState/GlobalState";

LicenseInfo.setLicenseKey(
  "ac8c44d2650f10c5456f59e7602dc69cTz0xMTE5MzIsRT0xNzc3MDc1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

export default function XGridDemo(props) {
  const {
    rows,
    titles,
    secondarySelected,
    setSecondarySelected,
    formik,
    data,
    type,
    withoutRowSelection,
    hideTotal = false,
  } = props;
  const [selected, setSelected] = useRecoilState(rowSelected);
  const { route } = useRecoilValue(routeInfo);
  const { row } = secondarySelected ? secondarySelected : selected;
  const setter = setSecondarySelected ? setSecondarySelected : setSelected;
  const columns = generateColumns(titles, route, formik, data, type);
  
  function SumFooter() {
    const apiRef = useGridApiContext();
    const ids = gridFilteredSortedRowIdsSelector(apiRef);
    
    const sum = ids.reduce((acc, id) => {
      const row = apiRef.current.getRow(id);
      const rawVal = row?.Monto ?? row?.['Monto Neto'] ?? row?.monto;
      return acc + rawVal;
    }, 0);
  
    return <div>
      {rows[0]?.Monto && !hideTotal && <div style={{textAlign: 'right', position: "absolute", bottom: "16px", left: "435px", fontWeight: "700"}}>
        Total: {formatNumber(sum)}
      </div>}
      <GridFooter/>
    </div>;
  }
  return (
    <>
      <DataGridPro
        columns={columns}
        rows={rows || []}
        onRowClick={
          withoutRowSelection
            ? () => {}
            : (data) => {
                if (data.row.id === row?.id) {
                  setter({ status: false, row: {} });
                  return;
                }
                setter({ status: true, row: data.row });
              }
        }
        selectionModel={row?.id || []}
        autoPageSize
        rowHeight={32}
        pagination
        hideFooterSelectedRowCount
        disableMultipleSelection
        disableColumnMenu
        localeText={{ ...esES.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: "Sin datos" }}
        components={{ Footer: SumFooter  }}
      />
    </>
  );
}
